// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selWidth[data-v-84b1627a]{width:300px}.total-count[data-v-84b1627a]{font-weight:bold;color:#e6a23c}.mt5[data-v-84b1627a]{margin-top:5px}.mt14[data-v-84b1627a]{margin-top:14px}.mt20[data-v-84b1627a]{margin-top:20px}.padding-add[data-v-84b1627a]{padding:20px}.block[data-v-84b1627a]{margin-top:20px;text-align:right}", ""]);
// Exports
module.exports = exports;
